import { useEffect } from "react";

const APP_BACKGROUND_VARIABLE = "--bs-app-bg-color";
const DEFAULT_APP_BACKGROUND = "#EFF6FA";

export function usePageBackgroundColor(backgroundColor?: string) {
  useEffect(() => {
    const root = document.documentElement;
    const nextBackground = backgroundColor || DEFAULT_APP_BACKGROUND;

    root.style.setProperty(APP_BACKGROUND_VARIABLE, nextBackground);

    return () => {
      root.style.setProperty(APP_BACKGROUND_VARIABLE, DEFAULT_APP_BACKGROUND);
    };
  }, [backgroundColor]);
}

export { DEFAULT_APP_BACKGROUND };
